import React from "react";
import { ItemRendererContextValue } from "./types";

export const flatListDefaults = {
  horizontal: true,
  showsHorizontalScrollIndicator: false,
  pagingEnabled: true,
  scrollEnabled: true,
  maxToRenderPerBatch: 3,
  initialNumToRender: 3,
  windowSize: 10,
};

export const GENERATED_LABEL_PREFIX = "Filter by";

export const MAX_DISPLAYED_FILTERS = 3;

export const scrollContentStyles = {
  display: "flex",
  flexGrow: 1,
  overflow: "visible",
} as const;

export class MissingLayoutDimensionsError extends Error {
  constructor() {
    super("Layout dimensions are missing.");
  }
}

export const ItemRendererContext =
  React.createContext<ItemRendererContextValue>({ dragging: false });
